import { render, staticRenderFns } from "./CatalogCardScoreEvolution.vue?vue&type=template&id=2a351814&scoped=true"
import script from "./CatalogCardScoreEvolution.vue?vue&type=script&lang=js"
export * from "./CatalogCardScoreEvolution.vue?vue&type=script&lang=js"
import style0 from "./CatalogCardScoreEvolution.vue?vue&type=style&index=0&id=2a351814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a351814",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QImg});
